import React from 'react';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import { FaCheckCircle } from 'react-icons/fa';
import SectionTitle from '../../elements/section-title/SectionTitle';

const GDGrowSection = ({
    title,
    subtitle,
    textAlignment,
    textColor,
    paragraphClass,
    data,
    imgUrl
}) => {
    return (
        <div className="section section-padding psm-grow-section bg-color-dark">
            <div className="container">
                <SectionTitle
                    subtitle={subtitle}
                    title={title}
                    textAlignment={textAlignment}
                    textColor={textColor}
                    paragraphClass={paragraphClass}
                />
                <div className="grow-inner">
                    {/* Left Side - Process Steps (Swapped) */}
                    <div className="col-lg-6 col-md-12">
                        <AnimationOnScroll animateIn="fadeInLeft" animateOnce={true}>
                            <div className="">
                                {/* Process Steps */}
                                <div className="psm--grow-container">
                                    {data.map((feature, index) => (
                                        <div className="psm-step-item" key={index}>
                                            <div className="psm-step-icon-wrapper">
                                                <FaCheckCircle className="psm-step-icon" />
                                            </div>
                                            <div className="psm-step-content">
                                                <h5 className="psm-step-title">{feature.title}</h5>
                                                <p className="psm-step-description">{feature.description}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </AnimationOnScroll>
                    </div>

                    {/* Right Side - Image (Swapped) */}
                    <div className="d-flex col-lg-6 col-md-12 mb-5 mb-lg-0 justify-content-center">
                        <AnimationOnScroll animateIn="fadeInRight" animateOnce={true}>
                            <div className="psm-image-wrapper">
                                <img
                                    src={process.env.PUBLIC_URL + imgUrl}
                                    alt="Growth Process"
                                    className="psm-grow-image"
                                />
                            </div>
                        </AnimationOnScroll>
                    </div>
                </div>
            </div>
            <ul className="list-unstyled shape-group-10">
                <li className="shape shape-1">
                    <img src={process.env.PUBLIC_URL + "/images/others/line-9.png"} alt="Circle" />
                </li>
                <li className="shape shape-2">
                    <img src={process.env.PUBLIC_URL + "/images/others/bubble-42.png"} alt="Circle" />
                </li>
                <li className="shape shape-3">
                    <img src={process.env.PUBLIC_URL + "/images/others/bubble-43.png"} alt="Circle" />
                </li>
            </ul>
            <style jsx>{`
 .shape-1-img {
     opacity: 0.2;
     max-width: 80%;
     float: inline-end;
}
 .shape-1-img-wrapper{
     top: 30px;
}
 .grow-inner{
     display: flex;
     flex-direction: row;
     align-items: center;
}
 .psm-grow-section {
     position: relative;
     overflow: hidden;
     padding: 110px 0px;
     padding-top: 50px;
}  
.psm-grow-section .title {
    margin-bottom: 0 !important;
}
 .psm-image-wrapper {
     position: relative;
     width: 100%;
     max-width: 500px;
     margin: 0 auto;
     float: right;
}
 .psm-grow-image {
     max-width: 500px;
     height: 500px;
     object-fit: cover;
}
 .psm-content-wrapper {
     position: relative;
}
 .psm-section-header {
     position: relative;
}
 .psm-subtitle {
     color: #FF6B6B;
     font-size: 16px;
     font-weight: 500;
     margin-bottom: 10px;
     text-transform: capitalize;
}
 .psm-title {
     color: #1a1a1a;
     font-size: 48px;
     font-weight: 700;
     line-height: 1.2;
     margin-bottom: 0;
}
 .psm-wave-line {
     position: absolute;
     top: 20px;
     right: 0;
     width: 350px;
     height: 50px;
     opacity: 0.6;
}
 .psm-step-item {
     display: flex;
     gap: 20px;
     margin-bottom: 30px;
     position: relative;
}
 .psm-step-item:last-child {
     margin-bottom: 0;
}
 .psm-step-icon-wrapper {
     flex-shrink: 0;
     margin-top: 5px;
}
 .psm-step-icon {
     font-size: 32px;
     color: #56e966; /* Using a primary color */
}
 .psm-step-content {
     flex: 1;
}
 .psm-step-title {
     color: white;
     font-size: 20px;
     font-weight: 600;
     margin-bottom: 8px;
     line-height: 1.3;
}
 .psm-step-description {
     color: white;
     font-size: 15px;
     line-height: 1.65;
     margin-bottom: 0;
}
/* Responsive Styles */
 @media (max-width: 991px) {
     .psm-title {
         font-size: 36px;
    }
     .psm-wave-line {
         width: 250px;
    }
     .shape-1-img {
         max-width: 40%;
    }
     .grow-inner{
         flex-direction: column-reverse;
    }
     .psm-grow-section {
         padding: 60px 0 30px;
    }
     .psm--grow-container {
         margin-top: 0px;
         margin-bottom: 40px;
    }
     .psm-image-wrapper {
         float: none;
         margin: 0 auto 30px;
     }

     .psm-grow-image {
     max-width: 400px;
     height: 400px;
}
}
 @media (max-width: 767px) {
     .psm-title {
         font-size: 32px;
    }
     .psm-wave-line {
         display: none;
    }
     .psm-step-icon {
          font-size: 24px;
     }
     .psm-step-title {
         font-size: 18px;
    }
     .psm-step-description {
         font-size: 14px;
    }
}
 @media (max-width: 575px) {
     .psm-title {
         font-size: 28px;
    }
     .psm-step-item {
         gap: 15px;
         margin-bottom: 25px;
    }
}
            `}</style>
        </div>
    );
};

export default GDGrowSection;
